import React from "react";
import { Box, Button, Dialog, MenuItem, TextField } from "@mui/material";
import { AddRounded } from "@mui/icons-material";
import PageTitle from "../../../components/PageTitle";
import Periods from "../../../utils/periods";
import { ProductDetail } from "../../main/query/topic/products/product-detail";
import { MessageDialog } from "../../../components/message-dialog";
import { productModelToDetails } from "../../../models/Product.model";
import { Loading } from "../../../components/loading";
import { AdminFilterBar, AdminPageHeader, countLabel } from "../../../components/ui";
import { getPeriodLabel } from "../../../utils/period-label";
import { productSchema, productViewInitial, useProductPage } from "./use-product-page";
import ProductTable from "./product-table";
import ProductFormModal from "./components/ProductFormModal";

export const ProductPage = () => {
    const {
        formik,
        subclassDisabled,
        setSubclassDisabled,
        activeDisabled,
        actives,
        subclasses,
        rowsPerPage,
        page,
        rowsProducts,
        formOpen,
        open,
        setOpen,
        selectedProduct,
        openBackdrop,
        productViewModel,
        setProductViewModel,
        searchProductModel,
        setSearchProductModel,
        btnSaveDisabled,
        dialogModel,
        closeForm,
        handleChangePage,
        handleChangeRowsPerPage,
        handleClickEnableProduct,
        handleClickViewProduct,
        handleClickEditProduct,
        searchProducts,
        openCreate,
    } = useProductPage();

    const total = rowsProducts.length > 0 ? rowsProducts[0].totalProducts : 0;

    return (
        <Box sx={{ width: "100%", p: { xs: "18px 16px 24px", md: 4 } }}>
            <PageTitle title="Produtos" />
            <Loading open={openBackdrop} />

            <AdminPageHeader
                title="Produtos"
                subtitle="Gestão de ativos — classes, dosagem, mecanismo e restrições."
                action={
                    <Button
                        variant="contained"
                        startIcon={<AddRounded />}
                        onClick={openCreate}
                        sx={{ height: 44, borderRadius: "12px", fontWeight: 600 }}
                    >
                        Novo produto
                    </Button>
                }
            />

            <ProductFormModal
                open={formOpen}
                onClose={closeForm}
                btnSaveDisabled={btnSaveDisabled}
                formik={formik}
                productViewModel={productViewModel}
                setProductViewModel={setProductViewModel}
                productViewInitial={productViewInitial}
                productSchema={productSchema}
                activeDisabled={activeDisabled}
                subclassDisabled={subclassDisabled}
                setSubclassDisabled={setSubclassDisabled}
                actives={actives}
                subclasses={subclasses}
            />

            {/* ── Search / filter bar ── */}
            <AdminFilterBar
                search={searchProductModel.productName ?? ""}
                onSearch={(v) => {
                    setSearchProductModel({ ...searchProductModel, productName: v });
                }}
                placeholder="Buscar por nome"
                count={countLabel(total, total)}
                filters={
                    <>
                        <TextField
                            select
                            label="Período"
                            size="small"
                            sx={{ minWidth: 160 }}
                            value={searchProductModel.period ?? "AMBOS"}
                            onChange={(event) => {
                                setSearchProductModel({ ...searchProductModel, period: event.target.value });
                            }}
                        >
                            {Periods.map((option) => (
                                <MenuItem key={option} value={option}>
                                    {getPeriodLabel(option)}
                                </MenuItem>
                            ))}
                        </TextField>
                        <TextField
                            select
                            label="Status"
                            size="small"
                            sx={{ minWidth: 140 }}
                            value={searchProductModel.disabledProduct ?? "AMBOS"}
                            onChange={(event) => {
                                setSearchProductModel({ ...searchProductModel, disabledProduct: event.target.value });
                            }}
                        >
                            {[
                                { value: "AMBOS", label: "Todos" },
                                { value: "ATIVO", label: "Ativo" },
                                { value: "INATIVO", label: "Inativo" },
                            ].map((opt) => (
                                <MenuItem key={opt.value} value={opt.value}>
                                    {opt.label}
                                </MenuItem>
                            ))}
                        </TextField>
                        <Button
                            variant="contained"
                            onClick={() => searchProducts()}
                            sx={{ height: 40, borderRadius: "12px", fontWeight: 600, flexShrink: 0 }}
                        >
                            Pesquisar
                        </Button>
                    </>
                }
            />

            <ProductTable
                rows={rowsProducts}
                rowsPerPage={rowsPerPage}
                page={page}
                count={total}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                onToggle={handleClickEnableProduct}
                onEdit={handleClickEditProduct}
                onView={handleClickViewProduct}
            />

            <Dialog open={open} onClose={() => setOpen(false)}>
                <ProductDetail detail={productModelToDetails(selectedProduct)} onClose={() => setOpen(false)} />
            </Dialog>

            <MessageDialog
                emoji={dialogModel.emoji}
                open={dialogModel.open}
                title={dialogModel.title}
                message={dialogModel.message}
                onConfirm={dialogModel.onConfirm}
                confirmButtonText={dialogModel.confirmButtonText}
            />
        </Box>
    );
};
